import { getContentstackImagesForWidths } from '@noths/polaris-client-utils';
import dynamic from 'next/dynamic';

import { lazyLoadImages } from 'src/utils/images';
import { YouTubeVideoBlockBlockSection } from '../../../components/sections/YouTubeVideoBlockSection';
import { SectionRenderer } from '../../../types/Section';
import { Transformer } from '../../../types/Transformer';
import { VideoBlockContentSection } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<YouTubeVideoBlockBlockSection> =
  dynamic<YouTubeVideoBlockBlockSection>(() =>
    import('../../../components/sections/YouTubeVideoBlockSection').then(
      (mod) => mod.YouTubeVideoBlockSection,
    ),
  );

export const transformer: Transformer<VideoBlockContentSection, YouTubeVideoBlockBlockSection> = (
  { _metadata, youtube_id, caption = '', title = '', thumbnail, tracking_title },
  { positionMetadata },
) => ({
  uid: _metadata.uid,
  props: {
    youtubeId: youtube_id,
    ...(thumbnail
      ? {
          thumbnailImages: getContentstackImagesForWidths(
            thumbnail.url,
            [360, 500, 700, 900, 1132],
            {
              aspectRatio: '16:9',
            },
          ),
          thumbnailWidth: 360,
          thumbnailHeight: 216,
        }
      : { thumbnailImages: [] }),
    title,
    caption,
    trackingTitle: tracking_title,
    lazyImages: lazyLoadImages(positionMetadata.position),
  },
});
